import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Footer from '../../components/Footer';
import 'wicg-inert';
import ScrollToTop from "../../libs/scrollToTop";
import { useKonami } from 'react-konami-code';
import Nav from '../../components/Nav.js';
import SecondaryNav from '../../components/SecondaryNav';

import heroMobileImage from '../../images/articles/wf-isf-perspectives-urban-forests_767x577.jpg';
import heroDesktopImage from '../../images/articles/wf-isf-perspectives-urban-forests_1164x584.jpg';

import bodyDesktopImage from '../../images/articles/wf-isf-expanded-goals-body1-desktop.jpg';
import bodyMobileImage from '../../images/articles/wf-isf-expanded-goals-body1-mobile.jpg';

import ModalOverlay from "../../components/ModalOverlay";

import EVShareMobile from '../../images/articles/EV-share-mobile.png';
import EVRangeMobile from '../../images/articles/EV-range-mobile.png';
import { fireTag } from '../../libs/analytics.js';

const UrbanForests = ({
						  handleEvent,
						  modalOverlay,
						  closeExitOverlay,
						  addExitClickListeners,
					  }) => {

	const [enableScrollGA, setEnableScrollGA] = useState(false);
	const [shouldBeInert, setShouldBeInert] = useState(false);
	const [gridVisible, setGridVisible] = useState(false);
	const heroOGImage = 'wf-isf-perspectives-electric-vehicles_ogimage.jpg';

	addExitClickListeners();

	const toggleInert = () => {
		setShouldBeInert(!shouldBeInert)
	}


	const toggleGrid = () => {
		const grid = document.getElementsByClassName('grid')[0];
		grid.style.display = (!gridVisible) ? 'none' : 'block';
		setGridVisible(!gridVisible)
	}

	const KonamiElement = () => {
		useKonami(toggleGrid, {
			code: [37, 39, 37, 39]
		});
		return <div className="grid" style={{display: gridVisible ? 'block' : 'none'}}/>;
	};

	const linkDisclosures = () => {
		const bodyDisclosures = document.querySelectorAll('.body-disclosures');
		const footerDisclosures = document.querySelectorAll('.footer-disclosures');
		bodyDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = footerDisclosures[disclosureNumber - 1];
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});

				window.setTimeout(() => {
					// console.log(' ======== ');
					// console.log(targetElement);
					targetElement.focus();
				}, 1000);

			});
		});

		footerDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = bodyDisclosures[disclosureNumber - 1];
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});
				window.setTimeout(() => {
					targetElement.focus();
				}, 1000);
			});
		});
	}


	useEffect(() => {

		// console.log(`To see grid overlay, type ↑ ↑ ↓ ↓ ← → ← → B A inside the browser window`);
		ScrollToTop(setEnableScrollGA)
		linkDisclosures();

	}, []); // empty array says only use this effect once

	let mastheadImage;
	let bodyImage;

	switch (true) {
		case (window.innerWidth < 768):
			mastheadImage = heroMobileImage;
			bodyImage = bodyMobileImage;
			break;
		case (window.innerWidth < 1440):
			mastheadImage = heroDesktopImage;
			bodyImage = bodyDesktopImage;
			break;
		case (window.innerWidth >= 1440):
			mastheadImage = heroDesktopImage;
			bodyImage = bodyDesktopImage;
			break;
	}
	// console.log(mastheadImage);
	// console.log(process.env.PUBLIC_URL);

	return (
		<>
			<Helmet>
				<title>Urban forests are great for people and the planet</title>
				<meta
					name="description"
					content="Challenges and solutions for growing and maintaining vital urban forests in New England’s cities."
				/>
				<meta property="og:title" content="Urban forests are great for people and the planet"/>
				<meta
					property="og:description"
					content="Challenges and solutions for growing and maintaining vital urban forests in New England’s cities."
				/>
				<meta property="og:image" content="https://welcome.wf.com/impact/images/articles/wf-isf-perspectives-urban-forests_ogimage.jpg" />

				<meta property="twitter:title" content="Urban forests are great for people and the planet"/>
				<meta
					property="twitter:description"
					content="Challenges and solutions for growing and maintaining vital urban forests in New England’s cities."
				/>
			</Helmet>
			{/*TODO: isMobile should be passed in from route, not calc'd here */}
			<Nav handleEvent={handleEvent} isNotHomePage={false} activePage="articles" isMobile={window.innerWidth < 768} showExternalNav toggleInert={toggleInert} shouldBeInert={shouldBeInert}/>
			{!window.innerWidth < 768 && (
				<SecondaryNav page="Articles" shouldBeInert={shouldBeInert} activePage="articles"/>
			)}

			<main className='flex-container article-5'>

				<div className="flex-row">
					{/*flex-col-md-8*/}
					<div className="flex-col-sm-12 headline">
						<h1 id="articles-main-h1" style={{marginBottom: 10}}>
							Urban forests are great for people and the planet
						</h1>
						<h2 className="summary">
							Challenges and solutions for growing and maintaining vital urban forests in New England’s cities.
						</h2>
					</div>

				</div>

				<div className="flex-row full-width exception goals">
					<div className="flex-col-lg-10 flex-col-md-10 text-center hero-container">
						<img src={mastheadImage} alt="A family walks down a tree-lined street. Father carries son on his shoulders."/>
					</div>
				</div>

				<div className="flex-row">
					<div className="flex-col-md-12 flex-col-sm-12 text-center article-intro info-graphic">
						<div className="by-line">
							<p>By <a onClick={()=>fireTag('A1','deanna moran')} target={"_blank"} href="https://www.clf.org/about/our-team/deanna-moran/" data-click-listener="true" rel="noreferrer">Deanna Moran</a>, <span>vice president, healthy & resilient communities at Conservation Law Foundation</span></p>
						</div>
						<div className="article-info">
							<div>
								<p>October 12, 2023</p>
							</div>
							<div>
								<p>7-minute read</p>
							</div>
						</div>

						<div className="flex-col-md-12 flex-col-sm-12 text-center red-border">
							<p>
								<strong>Editor's note:</strong> Wells Fargo philanthropically supports sustainability initiatives from a variety of organizations and periodically invites them to share their perspectives relating to their work. Conservation Law Foundation aims to protect New England’s environment — including the places people live, work, and play — for the benefit of all. This article reflects the organization’s mission to preserve our natural resources, build healthy communities, and sustain a vibrant economy. The viewpoints expressed may or may not reflect the opinions of Wells Fargo.
							</p>
						</div>


						<p>My family planted a Jane Magnolia tree in our front yard on Earth Day. We picked this tree because it will be happy in our changing climate, it sits on our town’s “preferred tree list,” it won’t shade our rooftop solar, and my husband likes pink flowers. But, despite our best efforts, it isn’t blossoming like we’d expected. We’re probably not watering it enough.</p>

						<p>We’re not the only ones struggling to grow trees. Across New England, property owners, community organizations, and cities and towns struggle with growing and preserving the trees, shrubs, plants, and mosses that make up our urban forests.</p>

						<p>Given the many health and climate benefits of trees in urban areas — more on those below — we at Conservation Law Foundation recently took a deep dive into strategies to help make our region’s urban forests thrive. We spoke with stakeholders, conducted research, and worked directly with communities across New England to understand the common challenges facing urban foresters and identify and test real-world solutions.</p>

						<p>Our findings, published in this <a onClick={()=>fireTag('A1','new report')} target="_blank" href="https://www.clf.org/wp-content/uploads/2023/08/CLF-Urban-Forestry-Report.pdf " data-click-listener="true" rel="noreferrer">new report</a>, provide a blueprint for accelerating efforts to grow and maintain urban forests in New England and beyond.</p>


						<h2 className="subhead">Why is the urban forest important?</h2>

						<p>Research shows that trees contribute to improved physical and mental health. But they also play an increasingly important role in protecting people from the effects of climate change, including extreme heat, wildfires, and stormwater flooding.</p>

						<ul className="copy-list">
							<li>
								<strong>Health benefits:</strong> Trees filter air pollution, which means better health for those suffering from respiratory ailments (and fewer of those ailments in the first place). <a onClick={()=>fireTag('A1','')} target="_blank" href="https://yaleclimateconnections.org/2023/02/the-little-known-physical-and-mental-health-benefits-of-urban-trees/" data-click-listener="true" rel="noreferrer">Researchers</a> have even quantified the health benefits of urban forests at nearly $7 billion, given that less air pollution means lower health care costs like visits to the hospital for respiratory illnesses.
							</li>
							<li>
								<strong>Cooling benefits:</strong> A <a onClick={()=>fireTag('A1','study')} target="_blank" href="https://www.boston.gov/sites/default/files/file/2022/04/04212022_Boston%20Heat%20Resilience%20Plan_highres-with%20Appendix%20%281%29.pdf" data-click-listener="true" rel="noreferrer">study</a> found a 29°F difference in surface temperature between unshaded asphalt and asphalt shaded by tree canopy. That sun-exposed asphalt gets too hot for pets and people to walk on without wearing paw protection and shoes. That’s why having lush tree canopies in urban areas is so important — both for keeping homes and sidewalks cooler and safer as well as outdoor spaces such as playgrounds, parks, and bike paths cooler during heat waves.
							</li>
							<li>
								<strong>Flooding benefits:</strong> Urban trees provide an important stormwater management function. <a onClick={()=>fireTag('A1','researchers')} target="_blank" href="https://www.fs.usda.gov/research/treesearch/64216" data-click-listener="true" rel="noreferrer">Researchers</a> showed that, after 31 trees were removed along a 1,300-foot stretch of road, stormwater volume during rainstorms increased by 30%. That means when we have trees helping to filtrate rain, we get less pollution running into our waterways and less damage to property when floods strike.
							</li>
						</ul>

						<p>These are just a few reasons why we must find ways to preserve and grow our communities’ urban forests. Here’s how.</p>

						<h2 className="subhead">Conduct tree inventories (even partial ones)</h2>

						<p>Urban forests provide the most benefits when they are diverse in species and age, evenly distributed across a community, and in good health. Tree inventories that record the location, characteristics, and condition of trees can help direct city resources to the most beneficial areas.</p>

						<p>A comprehensive inventory can be costly and time intensive to produce, but some information can be gathered quickly through satellite imagery and then built on over time. If a complete tree inventory seems like too big a lift, cities can create partial inventories that prioritize data collection and planting in neighborhoods with the least tree canopy. We know that these are more likely to be lower-income neighborhoods and neighborhoods of color — due, in part, to the long-lasting effects of redlining. Prioritizing these areas first — and expanding the tree inventory over time — helps to promote tree equity in communities. For example, in Holyoke, Massachusetts, urban foresters conducted a partial inventory in four environmental justice neighborhoods in an effort to implement the city's first-of-its-kind <a onClick={()=>fireTag('A1','urban forest equity plan')} target="_blank" href="https://storage.googleapis.com/proudcity/holyokema/uploads/2021/10/Holyoke-UFEP_For-Web.pdf" data-click-listener="true" rel="noreferrer">Urban Forest Equity Plan</a>. This allowed the city to prioritize limited urban forest resources to the areas that needed and would benefit from them the most.
						</p>

						<h2 className="subhead">Find ways to minimize land use conflicts</h2>

						<p>In compact New England communities, there is fierce competition for space on the ground (and below the ground and above the ground). Small patches of land prime for tree planting are often already claimed by overhead electrical wires, underground utility infrastructure, parking areas, and bicycle lanes. If used for tree planting, some of these spaces would then create a shade conflict with existing or planned solar panel installations.</p>

						<p>In dealing with overhead conflicts with electric wires and solar panels, sometimes selecting smaller tree species can allow for both uses to coexist. A city or town can distribute a “preferred tree list” identifying suitable planting options for these sites. In areas where there’s not enough room for all of these necessary uses, design and engineering solutions (like <a onClick={()=>fireTag('A1','suspended pavement')} target="_blank" href="https://www.brightsidestl.org/what-we-do/demonstration-garden/silva-cells/" data-click-listener="true" rel="noreferrer">suspended pavement</a>) can add space for trees. Being intentional about where we put bike paths, sidewalks, trees, and utility lines can help preempt conflicts down the road (literally and figuratively). <a onClick={()=>fireTag('A1','new technology')} target="_blank" href="https://knowledge-center.solaredge.com/sites/kc/files/performance_of_pv_topologies_under_shaded_conditions.pdf" data-click-listener="true" rel="noreferrer">New technology</a> is available that could allow solar panels and shade trees to be located together without undermining either one’s effectiveness.
						</p>

						<h2 className="subhead">Urban forest funding and strategies for reducing costs</h2>

						<p>Urban forestry can take a lot of time and money. Many factors contribute to the cost of planting trees: where a tree is sourced, how it is prepared for transport and delivered, the readiness of the planting site, and how the tree is planted and will be cared for.</p>

						<p>In some cases, cost-saving measures for one of these steps can increase costs elsewhere in the process. For example, sourcing a smaller bare-root tree from a local nursery could cost less for the tree itself as well as its delivery and planting. The city of Burlington, Vermont, partners with a nonprofit organization called <a onClick={()=>fireTag('A1','branch out burlington')} target="_blank" href="https://branchoutburlington.org/programs/burlington-community-seeding-nursery/" data-click-listener="true" rel="noreferrer">Branch Out Burlington</a> that operates a local bare-root nursery. Through this partnership, the city has been able to radically reduce its planting costs per tree, which means more trees planted every year. But planting bare-root trees could mean a higher cost of maintenance in the beginning, until the tree becomes established. On the other hand, starting with larger trees that require machinery for planting can be expensive up front but might require less maintenance.
						</p>

						<p>There isn’t one right answer. Each community needs to assess its funding sources and staff and volunteer availability to determine its most economical path. If a community’s funding sources will cover the cost of planting trees but not tree maintenance or site preparation (as is typical), then the community might need to buy fewer, more expensive trees that can be maintained by a few city employees or a small group of volunteers. Making urban forestry funds more flexible could help communities buy more less-expensive trees and pay contractors to maintain them until they reach maturity, greatly increasing canopy coverage.</p>

						<h2 className="subhead">Thriving urban forests: Continuing the conversation</h2>

						<p>This is just a snapshot of what our research uncovered. You can read more about the <a onClick={()=>fireTag('A1','solutions to common urban forestry challenges')} target="_blank" href="https://www.clf.org/wp-content/uploads/2023/08/CLF-Urban-Forestry-Report.pdf" data-click-listener="true" rel="noreferrer">solutions to common urban forestry challenges</a> in our report.</p>

						<p>We know that even common challenges can look a little different in individual communities. In some cases, a community might have found a working solution that we haven’t identified. In other cases, no known solution may exist. That’s why we will continue to explore opportunities to help accelerate urban forestry in New England. Learn more about our work at <a onClick={()=>fireTag('A1','clf.org')} target="_blank" href="https://www.clf.org/" data-click-listener="true" rel="noreferrer">clf.org</a>.
						</p>


					</div>


				</div>

				<div className="keyline flex-col-md-12 flex-col-sm-12 text-center no-padding" style={{maxWidth: '928px'}}/>

				<div className="flex-row" style={{maxWidth: '928px'}}>

					<div className="flex-col-md-12 flex-col-sm-12 text-center disclosures">
						<div>
							<p>Conservation Law Foundation produced the report “Urban Forestry: Advancing Climate Resilience and Health Through Urban Forestry” with support from the Wells Fargo Foundation.</p>
						</div>
					</div>
				</div>
				{/*<KonamiElement className="grid"/>*/}

			</main>

			<Footer id="footer" footerStyles="global" shouldBeInert={shouldBeInert} activePage="sustainability" enableScrollGA={enableScrollGA}/>
			{/* Adobe retargeting tag */
			}
			{
				/*
					REMOVE TAG
					<img alt="" src="https://rtd-tm.everesttech.net/upi/?sid=s6cvr4h2qH04B3WUwCOG&cs=1" style={{display: 'none'}}/>
				*/
			}

			{
				modalOverlay && modalOverlay.open && (
					<ModalOverlay closeExitOverlay={closeExitOverlay} modalOverlay={modalOverlay}/>
				)
			}
		</>
	);
};

export default withRouter(UrbanForests);
